import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Battery.svg",
  "use": "Battery.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Battery.svg\"><path d=\"M57.0208,37.0209a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1,3,3,0,0,1,3,3v4A3,3,0,0,1,57.0208,37.0209Zm-47-17h40a4,4,0,0,1,4,4v16a4,4,0,0,1-4,4h-40a4,4,0,0,1-4-4v-16A4,4,0,0,1,10.0209,20.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol